import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import ButtonStyles, { OutlineWhiteButtonStyles, SolidWhiteButtonStyles, } from '@stories/Components/Buttons/Button/Button.styles';
import { rgba } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle `
  :root {
    --headerHeight: 56px;

    padding-top: var(--headerHeight);

    @media ${from(Device.DesktopSmall)} {
      --headerHeight: 88px;    
    }
  }
`;
const Container = styled.header `
  ${transition('background-color')};

  position: fixed;
  z-index: ${Layers.Header};
  top: 0;
  left: 0;
  width: 100%;
  background-color: transparent;

  [data-has-announcement-bar='true'] & {
    margin-top: var(--announcementBarHeight);
  }

  &[data-solid='true'] {
    background-color: ${brand.primary.white};
  }
`;
const Shadow = styled.span `
  ${transition('opacity')};

  display: block;
  position: fixed;
  z-index: ${Layers.Header - 1};
  top: var(--headerHeight);
  left: 0;
  width: 100%;
  height: 1px;
  box-shadow: 0px 0px 8px 3px ${rgba(brand.primary.black, 0.33)};
  opacity: 0;

  &[data-solid='true'] {
    opacity: 1;
  }
`;
const Inner = styled.div `
  ${siteWide};

  display: flex;
  align-items: center;
  gap: ${fluid(16, 24)};
  height: var(--headerHeight);

  @media ${from(Device.DesktopSmall)} {
    gap: ${fluid(32, 56)};
  }

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(32, 40)};
    --borderWidth: 2px;
    --fontSize: ${fluid(13, 16)};
  }

  > ${ButtonStyles.Container}[data-type='solid-white'] {
    --colourText: ${brand.primary.orange};
    --colourTextDisabled: ${rgba(brand.primary.orange, 0.8)};
    --colourTextHover: ${brand.primary.orange};

    @media ${from(Device.DesktopSmall)} {
      display: none;
    }
  }
`;
const Logo = styled.a `
  --width: 84px;

  display: grid;
  place-content: center;
  width: var(--width);
  aspect-ratio: 84 / 24;

  svg {
    ${transition('opacity')};

    display: block;
    width: 100%;
    grid-area: 1 / 1 / 1 / 1;

    &:first-of-type {
      opacity: 0;
    }
  }

  ${Container}[data-solid='true'] & {
    svg {
      &:first-of-type {
        opacity: 1;
      }

      &:last-of-type {
        opacity: 0;
      }
    }
  }

  @media ${from(Device.DesktopSmall)} {
    --width: 141px;
  }
`;
const CtaLinks = styled.div `
  display: flex;
  gap: ${fluid(16, 24)};
  margin-left: auto;

  ${ButtonStyles.Container} {
    @media ${until(Device.DesktopSmall)} {
      &:not(:first-of-type) {
        display: none;
      }
    }

    @media ${from(Device.DesktopSmall)} {
      &:first-of-type:not(:last-of-type) {
        display: none;
      }
    }
  }
  ${Container}[data-solid='false'] & {
    @media ${until(Device.DesktopSmall)} {
      ${ButtonStyles.Container}[data-type='solid'] {
        ${OutlineWhiteButtonStyles};
      }
    }

    @media ${from(Device.DesktopSmall)} {
      ${ButtonStyles.Container}[data-type='outline-black'] {
        ${OutlineWhiteButtonStyles};
      }

      ${ButtonStyles.Container}[data-type='solid'] {
        ${SolidWhiteButtonStyles};

        --colourText: ${brand.primary.orange};
      }
    }
  }
`;
const StyledLink = styled.a `
  text-decoration: none;
`;
const HeaderStyles = {
    Container,
    CtaLinks,
    GlobalStyles,
    Inner,
    Logo,
    Shadow,
    StyledLink,
};
export default HeaderStyles;
